import React from "react";
import PortfolioContainer from "./components/PortfolioContainer/PortfolioContainer";
// import Footer from "./components/Footer/Footer"
import "./style.css"

const App = () => 
<div className="App">
<PortfolioContainer />
{/* <Footer /> */}
</div>
;

export default App;